<template>
    <client-page class="app--main">
        <!-- S: main-visual -->
        <main-visual></main-visual>
        <!-- E: main-visual -->

        <!-- S: service -->
        <section class="main-section main-section--service pb-0">
            <div class="tit-wrap tit-wrap--center">
                <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                <h2 class="tit tit--xl mb-24" data-aos="fade-up">Service</h2>
                <p class="page-text page-text--lg font-weight-medium" data-aos="fade-up" data-aos-delay="100">(주)모두에프엔티의 모토는 최고의 상품과 최상의 마켓정보를 통해 <br class="d-none d-md-block" />고객 분들께 최선의 서비스를 제공하는 것 입니다.</p>
            </div>

            <v-card flat tile class="service-card white--text">
                <v-row no-gutters>
                    <v-col cols="6" md="3">
                        <router-link class="service-card__link b-right b-bottom" align="center" to="/company/greeting">
                            <div class="service-card__inner">
                                <p class="page-text page-text--xs mb-12" data-aos="fade-up">About</p>
                                <h3 class="tit" data-aos="fade-up">
                                    회사소개
                                </h3>
                                <v-btn fab color="secondary" class="rounded-lg">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </div>
                        </router-link>
                    </v-col>

                    <v-col cols="6" md="3">
                        <router-link class="service-card__link b-bottom b-right--md" align="center" to="/business/overview">
                            <div class="service-card__inner">
                                <p class="page-text page-text--xs mb-12" data-aos="fade-up">Business</p>
                                <h3 class="tit" data-aos="fade-up">
                                    사업개요
                                </h3>
                                <v-btn fab color="secondary" class="rounded-lg">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </div>
                        </router-link>
                    </v-col>

                    <v-col cols="6" md="3">
                        <router-link class="service-card__link b-right" align="center" to="/product">
                            <div class="service-card__inner">
                                <p class="page-text page-text--xs mb-12" data-aos="fade-up">Products</p>
                                <h3 class="tit" data-aos="fade-up">
                                    제품안내
                                </h3>
                                <v-btn fab color="secondary" class="rounded-lg">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </div>
                        </router-link>
                    </v-col>

                    <v-col cols="6" md="3">
                        <router-link class="service-card__link" align="center" to="/service/inquiry">
                            <div class="service-card__inner">
                                <p class="page-text page-text--xs mb-12" data-aos="fade-up">Contact us</p>
                                <h3 class="tit" data-aos="fade-up">
                                    고객센터
                                </h3>
                                <v-btn fab color="secondary" class="rounded-lg">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </div>
                        </router-link>
                    </v-col>
                </v-row>
            </v-card>
        </section>
        <!-- E: service -->

        <!-- S: products -->
        <section class="main-section main-section--products">
            <v-container>
                <v-row no-gutters>
                    <v-col cols="12" md="4">
                        <div class="tit-wrap main-section--products__tit">
                            <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                            <h2 class="tit tit--xl" data-aos="fade-right">Products</h2>
                        </div>
                        <div class="swiper-nav">
                            <div class="swiper-button-prev">
                                <icon-arrow-rounded direction="left" class="grey--text text--darken-4 icon--size-x-large" />
                            </div>
                            <span class="swiper-nav__line"></span>
                            <div class="swiper-button-next">
                                <icon-arrow-rounded direction="right" class="grey--text text--darken-4 icon--size-x-large" />
                            </div>
                        </div>
                    </v-col>
                    <v-col md="8">
                        <div class="products-slide">
                            <div class="swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide">
                                        <img src="/images/main/product01.png" class="mb-16 mb-md-32" />
                                        <div class="tit-wrap tit-wrap--xs">
                                            <h3 class="tit tit--sm">
                                                소스류 [OEM 가능]
                                            </h3>
                                        </div>
                                        <p class="page-text page-text--sm grey--text mb-16 mb-md-32">
                                            업소용 케첩&마요네즈, 돈까스소스, 떡볶이 소스, 쫄면장 소스, <br class="d-none d-xl-block" />
                                            콘버터용 소스, 간장소스, 우동소스, 각종 샐러드 드레싱, 각종 <br class="d-none d-xl-block" />
                                            과일 잼 등, OEM 소스 생산 MOQ 200kg이상
                                        </p>
                                        <v-btn fab outlined color="secondary" class="rounded-lg" to="/product#1">
                                            <icon-arrow-rounded direction="right" class="icon--size-small" />
                                        </v-btn>
                                    </div>

                                    <div class="swiper-slide">
                                        <img src="/images/main/product02.png" class="mb-16 mb-md-32" />
                                        <div class="tit-wrap tit-wrap--xs">
                                            <h3 class="tit tit--sm">
                                                제과제빵류
                                            </h3>
                                        </div>
                                        <p class="page-text page-text--sm grey--text mb-16 mb-md-32">
                                            각종 페스츄리 생지, 크로와상 생지 (미니 사이즈도 보유), 데니쉬 <br class="d-none d-xl-block" />
                                            파이 생지, 애플 코로네 생지 , 뺑오 쇼콜라 생지, 베이글 등
                                        </p>
                                        <v-btn fab outlined color="secondary" class="rounded-lg" to="/product#2">
                                            <icon-arrow-rounded direction="right" class="icon--size-small" />
                                        </v-btn>
                                    </div>

                                    <div class="swiper-slide">
                                        <img src="/images/main/product03.png" class="mb-16 mb-md-32" />
                                        <div class="tit-wrap tit-wrap--xs">
                                            <h3 class="tit tit--sm">
                                                공산품식자재류
                                            </h3>
                                        </div>
                                        <p class="page-text page-text--sm grey--text mb-16 mb-md-32">
                                            밀가루, 참기름, 식용유, 들기름, 식초, 액젓, 설탕 등
                                        </p>
                                        <v-btn fab outlined color="secondary" class="rounded-lg" to="/product#3">
                                            <icon-arrow-rounded direction="right" class="icon--size-small" />
                                        </v-btn>
                                    </div>

                                    <div class="swiper-slide">
                                        <img src="/images/main/product04.png" class="mb-16 mb-md-32" />
                                        <div class="tit-wrap tit-wrap--xs">
                                            <h3 class="tit tit--sm">
                                                파스타면 외 면류
                                            </h3>
                                        </div>
                                        <p class="page-text page-text--sm grey--text mb-16 mb-md-32">
                                            파스타 면, 스파게티 면, 페투치니 면. 라면사리, 칼국수 사리, 쫄면 <br class="d-none d-xl-block" />
                                            사리 등
                                        </p>
                                        <v-btn fab outlined color="secondary" class="rounded-lg" to="/product#5">
                                            <icon-arrow-rounded direction="right" class="icon--size-small" />
                                        </v-btn>
                                    </div>

                                    <div class="swiper-slide">
                                        <img src="/images/main/product05.png" class="mb-16 mb-md-32" />
                                        <h3 class="tit tit--sm mb-12">
                                            치즈 및 유제품류
                                        </h3>
                                        <p class="page-text page-text--sm grey--text mb-16 mb-md-32">
                                            체다치즈, 고르곤졸라 치즈, 아이스크림 믹스, 연유, 휘핑크림 등
                                        </p>
                                        <v-btn fab outlined color="secondary" class="rounded-lg" to="/product#4">
                                            <icon-arrow-rounded direction="right" class="icon--size-small" />
                                        </v-btn>
                                    </div>

                                    <div class="swiper-slide">
                                        <img src="/images/main/product06.png" class="mb-16 mb-md-32" />
                                        <h3 class="tit tit--sm mb-12">
                                            냉동/냉장가공 식품류
                                        </h3>
                                        <p class="page-text page-text--sm grey--text mb-16 mb-md-32">
                                            냉동만두, 볶음밥, 냉동 수산물, 냉동 홍시, 락교, 동그랑땡, 돈까스, <br class="d-none d-xl-block" />
                                            치킨까스, 오징어 링, 새우 튀김 등
                                        </p>
                                        <v-btn fab outlined color="secondary" class="rounded-lg" to="/product#6">
                                            <icon-arrow-rounded direction="right" class="icon--size-small" />
                                        </v-btn>
                                    </div>

                                    <div class="swiper-slide">
                                        <img src="/images/main/product07.png" class="mb-16 mb-md-32" />
                                        <h3 class="tit tit--sm mb-12">
                                            육가공류 및 포장육류
                                        </h3>
                                        <p class="page-text page-text--sm grey--text mb-16 mb-md-32">
                                            함박 스테이크, 베이컨, 바베큐폴드포크, 오리슬라이스, 모듬 <br class="d-none d-xl-block" />
                                            소세지, 데리야키 치킨, 불고기 등
                                        </p>
                                        <v-btn fab outlined color="secondary" class="rounded-lg" to="/product#7">
                                            <icon-arrow-rounded direction="right" class="icon--size-small" />
                                        </v-btn>
                                    </div>

                                    <div class="swiper-slide">
                                        <img src="/images/main/product08.png" class="mb-16 mb-md-32" />
                                        <h3 class="tit tit--sm mb-12">
                                            야채/신선식품류
                                        </h3>
                                        <p class="page-text page-text--sm grey--text mb-16 mb-md-32">
                                            배추, 양배추, 양파, 대파, 깻잎, 무, 고구마, 토마토, 단호박, <br class="d-none d-xl-block" />
                                            아스파라거스 등 가락시장에서 직접 입찰해 공수
                                        </p>
                                        <v-btn fab outlined color="secondary" class="rounded-lg" to="/product#8">
                                            <icon-arrow-rounded direction="right" class="icon--size-small" />
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <!-- E:products -->

        <!-- S: contact -->
        <section class="main-section main-section--contact pt-0">
            <div class="h-300px h-lg-600px">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.1213528284475!2d127.22307098860779!3d37.52863656001022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357cb23ba131d1cf%3A0x426f880eb3cef2dd!2z6rK96riw64-EIO2VmOuCqOyLnCDssL3smrDroZwgMzgtMzU!5e0!3m2!1sko!2skr!4v1687430444070!5m2!1sko!2skr" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <v-container data-aos="fade-up" class="mt-n60 mt-lg-n172">
                <v-card flat color="primary darken-4" class="white--text">
                    <div class="px-20 py-50 py-md-74 pa-lg-100">
                        <v-row no-gutters>
                            <v-col cols="12" md="6">
                                <div class="tit-wrap mb-20 mb-md-0">
                                    <v-img class="tit-wrap__img" src="/images/common/tit-img-white.png"></v-img>
                                    <h3 class="tit tit--xl">
                                        Contact Us
                                    </h3>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" class="line-height-11">
                                <div>
                                    <v-row no-gutters>
                                        <v-col cols="12" md="auto">
                                            <p class="page-text page-text--lg font-weight-bold w-120px w-lg-160px mb-6 mb-md-0">
                                                Address
                                            </p>
                                        </v-col>
                                        <v-col cols="12" md="">
                                            <p class="page-text page-text--lg font-weight-medium">
                                                경기도 하남시 창우로 38-35번지
                                            </p>
                                        </v-col>
                                    </v-row>
                                </div>

                                <div class="mt-16 mt-md-24 mt-md-32">
                                    <v-row no-gutters>
                                        <v-col cols="12" md="auto">
                                            <p class="page-text page-text--lg font-weight-bold w-120px w-lg-160px mb-6 mb-md-0">
                                                Tel
                                            </p>
                                        </v-col>
                                        <v-col cols="12" md="">
                                            <p class="page-text page-text--lg font-weight-medium">
                                                02-487-7350
                                            </p>
                                        </v-col>
                                    </v-row>
                                </div>

                                <div class="mt-16 mt-md-24 mt-md-32">
                                    <v-row no-gutters>
                                        <v-col cols="12" md="auto">
                                            <p class="page-text page-text--lg font-weight-bold w-120px w-lg-160px mb-6 mb-md-0">
                                                Fax
                                            </p>
                                        </v-col>
                                        <v-col cols="12" md="">
                                            <p class="page-text page-text--lg font-weight-medium">
                                                02-486-2189
                                            </p>
                                        </v-col>
                                    </v-row>
                                </div>

                                <div class="mt-16 mt-md-24 mt-md-32">
                                    <v-row no-gutters>
                                        <v-col cols="12" md="auto">
                                            <p class="page-text page-text--lg font-weight-bold w-120px w-lg-160px mb-6 mb-md-0">
                                                E-mail
                                            </p>
                                        </v-col>
                                        <v-col cols="12" md="">
                                            <p class="page-text page-text--lg font-weight-medium">
                                                MODOO456@naver.com
                                            </p>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
            </v-container>
        </section>
        <!-- E: contact -->

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MainBanners from "@/components/client/main/main-banners.vue";
import MainSection from "@/components/client/main/main-section.vue";
import MainVisual from "@/components/client/main/main-visual.vue";
import MainTextBanner from "@/components/client/main/main-text-banner.vue";
import MainAuctionsBanner from "@/components/client/main/main-auctions-banner.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";
import Swiper from "swiper/bundle";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        MainBanners,
        MainSection,
        MainVisual,
        MainTextBanner,
        MainAuctionsBanner,
        // BoardList,
        PopupLayer,
        LocaleSelect,
        IconArrowRounded,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 1,
                    spaceBetween: 128,
                    speed: 1000,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            });
        },
    },
};
</script>
